/*
 *
 * LanguageProvider actions
 *
 */import { CHANGE_LOCALE } from './constants';

export default function changeLocale(languageLocale) {
  return {
    type: CHANGE_LOCALE,
    locale: languageLocale,
  };
}
